import styled from 'styled-components'
import { height, HeightProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<HeightProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 404px;
  flex-grow: 1;
  border-radius: 16px;
  overflow: hidden;
  background-color: ${themeGet('colors.background.screen')};
  box-shadow: ${themeGet('shadows.block')};
  padding: ${themeGet('space.5')}px;

  > img {
    width: 100%;
    object-fit: contain;
    border-radius: 12px;
  }

  ${height}
`

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 300px;
  background-color: ${themeGet('colors.background.screenAlt')};
  border-radius: 12px;
`

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')}px;
  color: ${themeGet('colors.primary.main')};

  &:hover {
    color: ${themeGet('colors.primary.dark')};
  }
`
